import Icon, { IconVariant, IconSize } from "./Icon";

export type { IconVariant, IconSize };
export default Icon;
